import { localizeNumber,
  unlocalizeNumber } from '@bigbank/interface-components';

export const unlocalizeFiNumber = val => unlocalizeNumber(val, { locale: 'fi' });
export const localizeFiNumber = val => localizeNumber(val, { locale: 'fi' });
